var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#E6F3FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6143 37.3169C15.2845 38.3536 16.3212 26.9506 24.6143 27.9872C21.5044 16.5842 39.1272 16.5842 38.0905 24.8773C48.4569 21.7674 48.4569 38.3536 39.1272 37.3169M26.6875 41.4635L31.8707 45.61M31.8707 45.61L37.0539 41.4635M31.8707 45.61V31.0971",
    stroke: "#374DA0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.d95ef0c9686e84f6d93caa61c72d892c.svg";
export { ForwardRef as ReactComponent };